import type {ReactElement} from 'react';
import React from 'react';
import {LayoutOptions} from '@Components/contextual-menu/components/contextual-menu-layout-button';
import styles from './layout-button.module.scss';

interface LayoutButtonProps {
  className?: string;
  layoutName: string;
  layoutFor: LayoutOptions;

  onClick(): void;
}

export function LayoutButton({className = '', onClick = $.noop, ...props}: LayoutButtonProps): ReactElement<any> | null {
  const getFolderName = (): string => {
    switch (props.layoutFor) {
      case LayoutOptions.MENU:
        return 'menu';
      case LayoutOptions.SCHEDULE:
        return 'schedule';
      default:
        return '';
    }
  };
  const getLayoutImageSource = (): string => {
    return `${window.PMW.util.asset_url(`images/postermaker/${getFolderName()}-layouts/${props.layoutName}.png`)}`;
  };
  return (
    <div onClick={onClick} className={`${className} flex-center hover-transition-all radius-4 ${styles.layoutImageContainer}`}>
      <img className={styles.layoutImage} src={`${getLayoutImageSource()}`} alt="" />
    </div>
  );
}
